import conversationsStatistics from './conversationsStatistics';
import operatorsStatistics from './operatorsStatistics';
import customerSuccessStatistics from './customerSuccessStatistics';
import operatorStatistics from './operatorStatistics';
import mutualTranslations from './mutual';

const translations = {
  ...conversationsStatistics,
  ...operatorsStatistics,
  ...customerSuccessStatistics,
  ...mutualTranslations,
  ...operatorStatistics,
};

export default translations;
